import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-logradouro',
  templateUrl: './text-logradouro.component.html',
  styleUrls: ['./text-logradouro.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextLogradouroComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
